import { render, staticRenderFns } from "./member_fansOrder.vue?vue&type=template&id=dc5f9244&scoped=true&"
import script from "./member_fansOrder.vue?vue&type=script&lang=js&"
export * from "./member_fansOrder.vue?vue&type=script&lang=js&"
import style0 from "./member_fansOrder.vue?vue&type=style&index=0&id=dc5f9244&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5f9244",
  null
  
)

export default component.exports